import { render, staticRenderFns } from "./MasterSize.vue?vue&type=template&id=1b93f6e4&scoped=true&"
import script from "./MasterSize.vue?vue&type=script&lang=js&"
export * from "./MasterSize.vue?vue&type=script&lang=js&"
import style0 from "../SalesForce.scss?vue&type=style&index=0&id=1b93f6e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b93f6e4",
  null
  
)

export default component.exports